
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift/printable",
      function () {
        return require("private-next-pages/gift/printable.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift/printable"])
      });
    }
  